<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <div class="a-title">
        <div>
          <el-input
            v-model="phone"
            style="width:200px"
            placeholder="请输入手机号">
          </el-input>
          <el-date-picker
            v-model="startTime"
            type="date"
            style="width: 200px;"
            placeholder="选择开始时间">
          </el-date-picker>
          <el-date-picker
            v-model="endTime"
            type="date"
            style="width: 200px;"
            placeholder="选择截止时间">
          </el-date-picker>
          <el-button
            @click="zidouSearch"
            type="primary"
            :loading="zidouLoading">紫豆餐饮统计</el-button>
          <el-button
            @click="txmSearch"
            type="primary"
            :loading="txmLoading">团小蜜餐饮统计</el-button>
        </div>
      </div>
    </base-header>
    <el-main>
      <div v-show="zidouPlay">
        <template>
          <p>时段发言量统计图</p>
          <img :src="zidouReportList.speak_count_period_pic_url" />
          <div id="picture"></div>
        </template>
      </div>
      <div v-show="txmPlay">
        <template>
          <div>
            <span>商家总收入：</span>
            {{txmReportList.total_income}}
          </div>
        </template>
      </div>
    </el-main>
    <el-footer class="footer">
    </el-footer>
  </el-container>
</template>

<script>
const { init } = require('echarts')

export default {
  name: 'Statistics',
  data () {
    return {
      zidouReportUrl: this.getDomain() + 'bmsummary/get_zidou_catering_report',
      txmReportUrl: this.getDomain() + 'bmsummary/get_txm_catering_report',
      ysdsReportUrl: this.getDomain() + 'bmsummary/get_ucenter_order_data',
      zidouReportList: {},
      txmReportList: {},
      zidouLoading: false,
      txmLoading: false,
      phone: undefined,
      startTime: undefined,
      endTime: undefined,
      zidouPlay: false,
      txmPlay: false,
      timeId: undefined,
      receive: undefined,
      times: 0
    }
  },
  methods: {
    transformTime (date) {
      return Math.round(date.getTime() / 1000) + 86399
    },
    zidouSearch () {
      if (this.phone === undefined || this.startTime === undefined || this.endTime === undefined) {
        this.$message.error('请输入完整信息进行查询')
      } else {
        this.txmPlay = false
        this.zidouPlay = true
        this.zidouLoading = true
        let params = {
          phone: this.phone,
          start_time: Math.round(this.startTime.getTime() / 1000),
          end_time: this.transformTime(this.endTime)
        }
        let handle = res => {
          this.zidouReportList = res.data.content
          window.open(this.zidouReportList.most_frq_user_data_url)
          window.open(this.zidouReportList.invite_data_url)
          window.open(this.zidouReportList.chatroom_period_data_url)
          this.createCharts()
        }
        let loadings = () => {
          this.zidouLoading = false
        }
        this.__axios(this.zidouReportUrl, params, handle, loadings)
      }
    },
    txmSearch () {
      if (this.phone === undefined || this.startTime === undefined || this.endTime === undefined) {
        this.$message.error('请输入完整信息进行查询')
      } else {
        this.zidouPlay = false
        this.txmPlay = true
        this.txmLoading = true
        let params = {
          phone: this.phone,
          start_time: Math.round(this.startTime.getTime() / 1000),
          end_time: this.transformTime(this.endTime)
        }
        let handle = res => {
          this.txmReportList = res.data.content
          window.open(this.txmReportList.product_result_zy_url)
          window.open(this.txmReportList.user_address_url)
          window.open(this.txmReportList.user_turnover_url)
        }
        let loadings = () => {
          this.txmLoading = false
        }
        this.__axios(this.txmReportUrl, params, handle, loadings)
      }
    },
    createCharts () {
      let myChart = init(document.getElementById('picture'))
      let option = {
        title: {
          text: '发言量最多的5个时段'
        },
        tooltip: {},
        legend: {
          right: '0%',
          data: [
            {
              name: '发言量',
              icon: 'circle'
            }
          ]
        },
        xAxis: {
          data: this.zidouReportList.mostfrq_5_period_data.map(item => item.hour)
        },
        yAxis: {},
        series: [{
          name: '发言量',
          type: 'bar',
          data: this.zidouReportList.mostfrq_5_period_data.map(item => item.speak_count)
        }]
      }
      myChart.setOption(option)
    }
  }
}
</script>

<style scoped>

  img {
    width: 700px;
    height: 300px;
  }

  #picture {
    width: 300px;
    height: 300px;
    display: inline;
  }
  .a-title {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top:5px;
  }

  .padding {
    padding: 10px;
  }

  .width-200 {
    width: 200px;
  }
</style>
